// frontend-web/src/pages/AdminScholarshipExam.jsx
import React, { useEffect, useState } from "react";
import api from "../api";

export default function AdminScholarshipExam() {
  const [classes, setClasses] = useState([]);
  const [subjects, setSubjects] = useState([]);

  const [title, setTitle] = useState("");
  const [type, setType] = useState("regular"); // regular | mega
  const [clazz, setClazz] = useState("");
  const [subjectId, setSubjectId] = useState("");
  const [numQuestions, setNumQuestions] = useState(20);
  const [durationSeconds, setDurationSeconds] = useState(3600);
  const [date, setDate] = useState("");
  const [time, setTime] = useState("");
  const [entryFee, setEntryFee] = useState(10);
  const [maxParticipants, setMaxParticipants] = useState(100);
  const [loading, setLoading] = useState(false);

  useEffect(()=>{
    api.get("/admin/classes").then(r=>setClasses(r.data));
    api.get("/admin/subjects").then(r=>setSubjects(r.data));
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    if (!title || !clazz || !subjectId || !date || !time) {
      alert("Title, class, subject and schedule required");
      return;
    }
    setLoading(true);
    try {
      const payload = {
        title,
        contest_type: type,  // align with backend model 'contest_type' if used
        clazz: parseInt(clazz),
        subject_id: parseInt(subjectId),
        num_questions: parseInt(numQuestions),
        duration_seconds: parseInt(durationSeconds),
        starts_at: `${date}T${time}`, // ISO-like; backend should parse
        entry_fee: parseFloat(entryFee),
        max_participants: parseInt(maxParticipants)
      };
      await api.post("/admin/scholarship_exam", payload);
      alert("Scholarship exam scheduled");
      // reset
      setTitle(""); setNumQuestions(20); setDurationSeconds(3600); setDate(""); setTime("");
    } catch (err) {
      console.error(err);
      alert(err?.response?.data?.error || "Error");
    } finally { setLoading(false); }
  };

  return (
    <div style={{padding:20}}>
      <h2>Schedule Scholarship / Mega Exam</h2>
      <form onSubmit={submit}>
        <input value={title} onChange={e=>setTitle(e.target.value)} placeholder="Exam Title" style={{width:"100%",padding:8,marginBottom:8}} />
        <select value={type} onChange={e=>setType(e.target.value)} style={{padding:8,marginBottom:8}}>
          <option value="regular">Scholarship</option>
          <option value="mega">Mega Scholarship</option>
        </select>
        <select value={clazz} onChange={e=>setClazz(e.target.value)} style={{width:"100%",padding:8,marginBottom:8}}>
          <option value="">Select Class</option>
          {classes.map(c=> <option key={c.id} value={c.id}>{c.name}</option>)}
        </select>
        <select value={subjectId} onChange={e=>setSubjectId(e.target.value)} style={{width:"100%",padding:8,marginBottom:8}}>
          <option value="">Select Subject</option>
          {subjects.filter(s=> !clazz || s.class_id === parseInt(clazz)).map(s=> <option key={s.id} value={s.id}>{s.name}</option>)}
        </select>

        <input type="number" value={numQuestions} onChange={e=>setNumQuestions(e.target.value)} placeholder="Number of Questions" style={{width:"100%",padding:8,marginBottom:8}} />
        <input type="number" value={durationSeconds} onChange={e=>setDurationSeconds(e.target.value)} placeholder="Duration (seconds)" style={{width:"100%",padding:8,marginBottom:8}} />

        <div style={{display:"flex",gap:8, marginBottom:8}}>
          <input type="date" value={date} onChange={e=>setDate(e.target.value)} style={{padding:8}} />
          <input type="time" value={time} onChange={e=>setTime(e.target.value)} style={{padding:8}} />
        </div>

        <input type="number" value={entryFee} onChange={e=>setEntryFee(e.target.value)} placeholder="Entry fee (₹)" style={{width:"100%",padding:8,marginBottom:8}} />
        <input type="number" value={maxParticipants} onChange={e=>setMaxParticipants(e.target.value)} placeholder="Max participants" style={{width:"100%",padding:8,marginBottom:8}} />

        <button type="submit" disabled={loading} style={{padding:8}}>{loading ? "Scheduling..." : "Schedule Exam"}</button>
      </form>
    </div>
  );
}
